module.exports = __webpack_public_path__ + "img/sirima_ehmke_10.7b3f60f6.jpg";